import { Link } from '@mui/material';
import Grid from '@mui/material/Grid';
import EmailInput from 'src/packages/polaris/components/FormElements/EmailInput';
import TextFormInput from '../../FormElements/TextFormInput';

import { type Control } from 'react-hook-form';
import type { IDoctorConfirmationForm } from '../useDoctorConfirmationContext';

const DoctorConfirmationContact = ({
  control,
}: {
  control: Control<IDoctorConfirmationForm, any>;
}) => {
  return (
    <>
      <div className="bp-inline-flex bp-w-full bp-flex-col bp-items-start bp-justify-start bp-gap-5 bp-text-gray-100">
        <div>
          <div className="bp-font-primary-main">
            Please provide your name and the email where you’d like to receive your results.
          </div>
          <div className="bp-font-primary-small bp-mt-3 bp-text-gray-70">
            Your information will only be shared with Buoy and our partner,{' '}
            <Link href="https://optimalmd.com/" target="_blank" rel="noreferrer">
              OptimalMD
            </Link>
            .
          </div>
        </div>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <TextFormInput
              autoComplete="given-name"
              control={control}
              name="firstName"
              label="Name*"
              placeholder="First name"
              errorMessage="Enter your first name"
              required
            />
          </Grid>
          <Grid item>
            <EmailInput control={control} label="Email*" required />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default DoctorConfirmationContact;
